import { toast } from "react-toastify";
import firebase from "firebase/compat/app";
toast.configure();

var user_api_url = process.env.REACT_APP_USER_API_URL;
var job_api_url = process.env.REACT_APP_JOB_API_URL;
var user_profile_url = process.env.REACT_APP_PROFILE_API_URL;
var elastic_search_api_url = process.env.REACT_APP_ELASTIC_SEARCH_API_URL;
var candidate_web_url = process.env.REACT_APP_CANDIDATE_WEB_URL;
var employer_web_url = process.env.REACT_APP_EMPLOYER_WEB_URL;
var google_api_key = process.env.REACT_APP_GOOGLE_API_KEY;
var messaging_app_url= process.env.REACT_APP_MESSAGING_APP_URL;

var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const ENV = {
  
  login_url: user_api_url + "member/login",
  signup_url: user_api_url + "member/signup",
  logout_url: user_api_url + "member/logout",
  elasticSearch_url: elastic_search_api_url,
  notificationurl: user_api_url + "member/notifications/",
  // email_send:user_api_url + "member/notifications/sendemail",
  email_send:messaging_app_url + "messaging/templates/sendemail",
  sms_send:messaging_app_url + "messaging/templates/sendsms",

  // sms_send:user_api_url + "member/notifications/sendsms",
  getEmployerTeamMembersUrl: user_api_url + "employer/team/",
  getUserMetaDataEnumsUrl: user_api_url + "user/metadata/constants",
  createjob_url: job_api_url + "employer/job",
  notesHistory_url:job_api_url + "employer/job/",
  updatebenifits_url: job_api_url + "employer/job/",
  getJobs_url: job_api_url + "employer/job",
  getJobUrl: job_api_url + "employer/job/",
  getTemplatesUrl: job_api_url + "employer/templates/",
  copyJobUrl: job_api_url + "employer/job/",
  updateJobUrl: job_api_url + "employer/job/",
  uploadFileUrl: job_api_url + "employer/job/",
  uploadLogoUrl: job_api_url + "employer/accounts/logo/upload",
  getFilesUrl: job_api_url + "employer/job/",
  removeFilesUrl: job_api_url + "employer/job/",
  getJobReqBenefits: job_api_url + "employer/job/",
  getJobReqLanguages: job_api_url + "employer/job/languages",
  getJobReqSoftSkills: job_api_url + "employer/job/softskills",
  updateJobReqSoftSkills: job_api_url + "employer/job/",
  updateJobReqLanguages: job_api_url + "employer/job/",
  accountsUrl : job_api_url + "employer/accounts/",

  // createAccountUrl: job_api_url + "employer/accounts/",
  getAccountsUrl: job_api_url + "employer/accounts",
  // updateAccountsUrl: job_api_url + "employer/accounts/",
  // getAccountUrl: job_api_url + "employer/accounts/",
  // getBenfitsUrl: job_api_url + "employer/accounts/",
  // updateBenfiturl: job_api_url + "employer/accounts/",
  // allContactsUrl: job_api_url + "employer/accounts/",


  getSkills: job_api_url + "skills",
  skills_url: job_api_url + "skills/categories?",
  getmetaSkills: job_api_url + "skills?",
  jobMetaDataEnumsUrl: job_api_url + "job/metadata/constants",
  searchUrl: job_api_url + "skills/languages",

  // accountbenefits_url: job_api_url + "employer/accounts/",
  // addaccountbenefits_url: job_api_url + "employer/accounts/",

  getcandidatedetails_url: user_profile_url + "candidate/profile/info/",
  getshortlisted_url: job_api_url + "employer/job/",
  generatejobid_url: job_api_url + "employer/job/accounts/",
  getTAsUrl: user_api_url + "employer/team/talentadvisors",
  getActiveTAsUrl: user_api_url + "employer/team/active/talentadvisors",
  getTAsactiveUrl: user_api_url + "employer/team/",
  applyJobUrl: candidate_web_url + "jobreq?",
  hmsLinkUrl: employer_web_url ,
  hmsUrl: job_api_url + "job/hms/",
  proxyLoginUrl: user_api_url + "member/proxylogin/",
  candidateProxyUrl: candidate_web_url + "proxylogin",
  job_boards: job_api_url+"employer/jobboards/",
  firebaseConfig: firebaseConfig,

  candidate_web_url: candidate_web_url,
  google_api_key: google_api_key,
  newUserSignup: user_api_url + "member/signup/",

  messaging_email_app_url:messaging_app_url+"messaging/templates?messagingType=EMAIL_INVITE",
  messaging_sms_app_url:messaging_app_url+"messaging/templates?messagingType=SMS_INVITE",
  // elasticSearch_url: elastic_search_api_url,

};

export function isNullOrEmpty(message) {
  if (message == "" || message == undefined || message == null || message == 'undefined') {
    return true;
  } else {
    return false;
  }
}

export function validateErrorResponse(errorResponse) {
  if (errorResponse.response === undefined) {
  } else {
    if (errorResponse.response.status === 401) {
      if (errorResponse.response.data.failure_code === "INVALID_USER") {
        window.location.href = "/";
      } else if (
        errorResponse.response.data.failure_code === "INVALID_USER_SESSION"
      ) {
        sessionExpired();
      } else if (
        errorResponse.response.data.failure_code === "INVALID_BEARER_TOKEN" ||
        errorResponse.response.data.failure_code === "MISSING_BEARER_TOKEN"
      ) {
        sessionExpired();
      }
    } else if (errorResponse.response.status === 404) {
      window.localStorage.setItem("account", "NewUser");
      window.location.href = "/";
    } else if (errorResponse.response.status === 400) {
          handleFailureCode(errorResponse)
    }
  }
}

const sessionExpired = () => {
  const query = new URLSearchParams(window.location.search);
  const hmsId = query.get("id");

  if (!isNullOrEmpty(window.localStorage.getItem("user"))) {
    clearStorage();
  } else if (!isNullOrEmpty(window.localStorage.getItem("account"))) {
    clearStorage();
  } else if (!isNullOrEmpty(hmsId)) {
    clearStorage();
  } else {
    window.localStorage.clear();
    sessionStorage.clear();
  }
};

const clearStorage = () => {
  toast.error("Session Expired. Login again");
  window.localStorage.clear();
  sessionStorage.clear();
  firebase
    .auth()
    .signOut()
    .then(function () {
      window.location.href = "/";
    })
    .catch(function () {
      window.location.href = "/";
    });
};


const handleFailureCode = (errorResponse) => {

  if(errorResponse.response.data.failure_code === "ACCOUNT_IN_USE"){
    toast.error("Account in use");
  }
  if(errorResponse.response.data.failure_code === "ACCOUNT_ADDRESS_IN_USE"){
    toast.error("Account address in use");
  }
  if(errorResponse.response.data.failure_code === "ACCOUNT_BENEFITS_IN_USE"){
    toast.error("Account benefits in use");
  }

}